import { render, staticRenderFns } from "./app-country.vue?vue&type=template&id=27edbe35&scoped=true&"
import script from "./js/app-country.js?vue&type=script&lang=js&"
export * from "./js/app-country.js?vue&type=script&lang=js&"
import style0 from "./app-country.vue?vue&type=style&index=0&id=27edbe35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27edbe35",
  null
  
)

export default component.exports